import api from "./api";
import { Cart } from "../model/types";

export const getCart = async (): Promise<Cart> => {
  const response = await api.get<Cart>("/cart");
  return response.data;
};

export const addCartItem = async (payload: {
  foodItemId: number;
  quantity: number;
}): Promise<Cart> => {
  const response = await api.post<Cart>("/cart/items", payload);
  return response.data;
};

export const updateCartItem = async (
  cartItemId: number,
  payload: { quantity: number }
): Promise<Cart> => {
  const response = await api.put<Cart>(`/cart/items/${cartItemId}`, payload);
  return response.data;
};

export const removeCartItem = async (cartItemId: number): Promise<Cart> => {
  const response = await api.delete<Cart>(`/cart/items/${cartItemId}`);
  return response.data;
};

export const clearCart = async (): Promise<Cart> => {
  const response = await api.delete<Cart>("/cart");
  return response.data;
};
